<template>
  <mu-card class="aio-input" id="weight-input">
    <mu-card-actions class="aio-input-header pointer" @click.native="openInput">
      <mu-flexbox justify="flex_start" style="height: 48px">
        <svg class="card-left-icon" width="16px" height="14px" viewBox="0 3 16 14" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <defs></defs>
          <path
            d="M15.0274359,4.84740771 C14.8735715,3.69796239 14.1860505,3 13.1481453,3 L7.99995032,3 L2.85178845,3 C1.81394954,3 1.12642845,3.69796239 0.972531032,4.84740771 C0.81863361,5.99685303 0,14.2824828 0,14.2824828 C0,15.3027795 0.841418509,16.1298905 1.87929054,16.1298905 L7.99998344,16.1298905 L14.1207095,16.1298905 C15.1585484,16.1298905 16,15.3027795 16,14.2824828 C15.9999338,14.2824828 15.1813002,5.99682048 15.0274359,4.84740771 L15.0274359,4.84740771 Z M8.04591753,7.64554054 C8.06671538,7.61930062 8.0855924,7.59156313 8.1017869,7.56210019 C8.4607153,7.11289617 9.37125021,5.94541497 9.23897857,5.81603848 C9.13482376,5.71449715 8.33910752,6.12020671 7.76869022,6.43176509 C7.55504867,6.54844484 7.3728026,6.65200463 7.27066796,6.71070262 C7.24397519,6.72362725 7.21910388,6.73863544 7.19456375,6.7548482 C7.18946364,6.75777821 7.18174724,6.76230346 7.18174724,6.76230346 L7.18221089,6.7627918 C7.00413763,6.8859827 6.89405477,7.09443707 6.91432274,7.32330388 C6.92501972,7.44499722 6.97121875,7.55506815 7.0413618,7.64554054 L4.14473213,7.64554054 C4.07713914,7.64554054 4.02236265,7.59169336 4.02236265,7.5252471 C4.02236265,5.52499022 5.67774519,3.89765927 7.71252279,3.89765927 C7.81707501,3.89765927 7.92474029,3.90231474 8.03253803,3.91139779 C8.94949775,3.98884788 9.7994606,4.3991478 10.4257141,5.06663803 C11.05571,5.7380675 11.4026829,6.6112123 11.4026829,7.5252471 C11.4026829,7.59169336 11.3479065,7.64554054 11.2803135,7.64554054 L8.04591753,7.64554054 L8.04591753,7.64554054 Z"
            id="Shape" stroke="none" fill="#69A7D9" fill-rule="evenodd"
            transform="translate(8.000000, 9.564945) scale(-1, 1) translate(-8.000000, -9.564945) "></path>
        </svg>
        <mu-flexbox-item class="left16" v-text="title" style="color: #69A7D9;"></mu-flexbox-item>
        <mu-flexbox-item align="right">
          <mu-icon-button
            iconClass="blueIcon"
            v-if="!isOpenInput"
            v-tooltip.top="$t('message.addEntryText')"
            class="card-bar-icon"
            :icon="'add_circle'"
          ></mu-icon-button>
          <mu-icon-button
            iconClass="blueIcon"
            v-if="isOpenInput"
            class="card-bar-icon"
            :icon="'remove_circle_outline'"
          ></mu-icon-button>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-card-actions>
    <form v-if="isOpenInput">
      <mu-card-text style="padding-bottom: 8px">
        <mu-row gutter>
          <mu-col width="50" tablet="50" desktop="50" v-if="$store.state.user.settings.weight.measure === 'kg'">
            <mu-text-field
              v-validate
              min="0"
              max="635"
              data-vv-validate-on="none"
              :data-vv-rules="'required|min_value:0|max_value:635'"
              data-vv-name="kg"
              data-vv-value-path="inputValue"
              :errorText="errors.first('kg')"
              type="number"
              label="KG"
              :hintText="$t('message.placeholderText')"
              v-model.number="model.kg"
              :fullWidth="true"
            />
          </mu-col>
          <mu-col width="50" tablet="50" desktop="50" v-if="$store.state.user.settings.weight.measure === 'lbs'">
            <mu-text-field
              v-validate
              min="0"
              max="1400"
              data-vv-validate-on="none"
              :data-vv-rules="'required|min_value:0|max_value:1400'"
              data-vv-name="lbs"
              data-vv-value-path="inputValue"
              :errorText="errors.first('lbs')"
              type="number"
              label="LBS"
              :hintText="$t('message.placeholderText')"
              v-model.number="model.lbs"
              :fullWidth="true"
            />
          </mu-col>
          <mu-col width="50" tablet="50" desktop="50" v-if="$store.state.user.settings.weight.measure === 'st-lbs'">
            <mu-text-field
              v-validate
              min="0"
              max="100"
              data-vv-validate-on="none"
              :data-vv-rules="'required|min_value:0|max_value:100'"
              data-vv-name="stones"
              data-vv-value-path="inputValue"
              :errorText="errors.first('stones')"
              type="number"
              label="ST"
              :hintText="$t('message.placeholderText')"
              v-model.number="model.stones"
              :fullWidth="true"
            />
          </mu-col>
          <mu-col width="50" tablet="50" desktop="50" v-if="$store.state.user.settings.weight.measure === 'st-lbs'">
            <mu-text-field
              v-validate
              min="0"
              max="13"
              data-vv-validate-on="none"
              :data-vv-rules="'required|min_value:0|max_value:13'"
              data-vv-name="pounds"
              data-vv-value-path="inputValue"
              :errorText="errors.first('pounds')"
              type="number"
              label="LBS"
              :hintText="$t('message.placeholderText')"
              v-model.number="model.pounds"
              :fullWidth="true"
            />
          </mu-col>
        </mu-row>

      </mu-card-text>
    </form>
  </mu-card>
</template>
<script>
  import './weight.css'

  export default {
    name: 'aio-weight',
    watch: {
      'model.stones': function () {
        this.trySubmitAndEmitValue();
      },
      'model.pounds': function () {
        this.trySubmitAndEmitValue();
      },
      'model.kg': function () {
        this.trySubmitAndEmitValue();
      },
      'model.lbs': function () {
        this.trySubmitAndEmitValue()
      }
    },
    data() {
      return {
        title: this.$t('message.cardWeight'),
        isOpenInput: false,
        model: {
          stones: null,
          pounds: null,
          lbs: null,
          kg: null
        }
      }
    },
    methods: {
      openInput() {
        this.isOpenInput = !this.isOpenInput;
      },
      trySubmitAndEmitValue() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid === true) {
              let model = {};
              if (self.$store.state.user.settings.weight.measure === 'kg') {
                model.kg = self.model.kg;
              }
              if (self.$store.state.user.settings.weight.measure === 'lbs') {
                model.lbs = self.model.lbs;
              }
              if (self.$store.state.user.settings.weight.measure === 'st-lbs') {
                model.stones = self.model.stones;
                model.pounds = self.model.pounds;
              }
              self.$emit('onValid', model);
            }
            else {
              self.$emit('onValid', null);
            }
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Weight.vue?119dc60e